import { render, staticRenderFns } from "./ProductExtLayer.vue?vue&type=template&id=7df936c8&scoped=true&"
import script from "./ProductExtLayer.vue?vue&type=script&lang=js&"
export * from "./ProductExtLayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df936c8",
  null
  
)

component.options.__file = "ProductExtLayer.vue"
export default component.exports